/**
 * @desc 文件上传
 */
import { OssFileDetail, OssUploadParam } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UploadFileParameter = OssUploadParam

const method = 'POST'
const url = '/nexus/oss/upload'

export const uploadFileApi = (
  data?: UploadFileParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<OssFileDetail>({
    method,
    url,
    data,
    ...config
  })
}

uploadFileApi.method = method
uploadFileApi.url = url
